<template>
  <div class="flex active-item align-initial ">
    <div class="img-box">
      <img :src="item.adImage" alt="" />
    </div>
    <div class="jobf-status" style="background: #A4A4A4" v-if="item.status === 2">
      <div>已结束</div>
    </div>
    <div v-else>
      <div class="jobf-status" v-if="item.isSign">
        <div>已报名</div>
      </div>
      <div class="jobf-status" v-if="!item.isSign && item.status === 1">
        <div>报名中</div>
      </div>
    </div>
    <div class="flex-grow flex flex-column flex-between align-start">
      <div class="flex m-b-10">
        <div class="title">{{item.title}}</div>
        <div class="ac-type">{{item.type === 1 ? '线上' : '线下'}}</div>
      </div>
      <div class="">
        <div class="line flex">
          <img class="icon" src="../assets/images/home/user_icon.png" alt="" />
          <p style="margin-right: 55px">主办方：{{item.sponsor}}</p>
          <p>限额：{{item.signLimit}}家</p>
        </div>
        <div class="line flex">
          <img class="icon" src="../assets/images/home/time-circle_icon.png" alt="" />
          <p>截止时间：{{item.signEndat}}</p>
        </div>
        <div class="line flex">
          <img class="icon" src="../assets/images/home/location_icon.png" alt="" />
          <p>参会地址：{{item.address}}</p>
        </div>
      </div>
    </div>
    <div class="button-list flex flex-end" v-if="itemType === 'detail' && item.status !== 2 && !item.isSign">
      <div class="button primary-btn m-l-24" @click="goSign">立即报名</div>
    </div>
    <div class="button-list flex flex-end" v-if="itemType !== 'detail'">
      <div class="button" :class="item.status === 2 ? 'gray-btn' : 'primary-border-btn'" @click="goDetail">查看详情</div>
      <div class="button primary-btn m-l-24" v-if="!item.isSign &&item.status !== 2" @click="goDetail">立即报名</div>
    </div>
  </div>
</template>

<script>
  import { activeSuccess } from '@/assets/js/msgbox'

  export default {
    name: 'activity-item',
    props: {
      itemType: null,
      item: {}
    },
    methods: {
      goDetail() {
        this.$router.push({
          path: "/index/jobfair/info",
          query: { jbid: this.item.id }
        });
      },
      goSign() {
        if (this.item.type === 1) { //线上，直接报名
          this.axios.get(`/wapi/activity/sign?activityId=${this.item.id}`).then(res => {
            if (res.success) {
              // 报名成功
              activeSuccess({ companyName: this.item.companyName }, this);
            }
          });
        } else {// 线下选座
          this.$router.push({
            path: "/index/jobfair/seat",
            query: { jbid: this.item.id }
          });
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import url('../assets/less/base.less');

  .active-item {
    padding-bottom: 22px;
    border-bottom: 1px solid #D2D2D2;
    margin-bottom: 24px;
    position: relative;
    overflow: hidden;
    border-radius: 4px;

    &:last-of-type {
      border-bottom: none;
      margin-bottom: 0;
    }

    .jobf-status {
      position: absolute;
      background: #FF7A45;
      color: #fff;
      font-weight: 500;
      font-size: 16px;
      top: 0;
      right: 0;
      width: 133px;
      height: 65px;
      line-height: 100px;
      text-align: center;
      padding-left: 0;
      transform: rotate(45deg) translate(26px, -55px)
    }

    .title {
      font-size: 20px;
      color: #222222;
      margin-right: 13px;
    }

    .ac-type {
      width: 52px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      background: #057CF9;
      border-radius: 4px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .line {
      margin-bottom: 6px;
      font-size: 16px;
      line-height: 22px;
      color: #8C8C8C;

      &:last-of-type {
        margin-bottom: 0;
      }

      .icon {
        width: 16px;
        height: 16px;
        margin-right: 3px;
      }
    }

    .button-list {
      position: absolute;
      right: 0;
      bottom: 40px;
    }

    .button {
      height: 40px;
      line-height: 40px;
      width: 112px;
    }
  }

  .img-box {
    width: 254px;
    height: 141px;
    margin-right: 34px;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// ActivityItem.vue?f0ec4fb6